import { Injectable } from '@angular/core';
import { VideoChatService } from './video-chat.service';

@Injectable({
  providedIn: 'root'
})
export class VideoChatAlertService {

  inVideoChat: boolean;
  win: any;
  patientId: number;

  constructor( private videoChatService: VideoChatService ) { }

  isInVideoChat(): boolean {
    return this.inVideoChat;
  }

  setOnVideoChat( patientId: number ) {
    this.patientId = patientId;
    this.inVideoChat = true;
  }

  setOffVideoChat( ) {
    this.inVideoChat = false;
  }

  async startVideoChat( ) {

    const videoChatRequest = await this.videoChatService
      .getVideoChatRequestPendienByPatient( this.patientId );

    if (videoChatRequest) {

      if ( this.win ) {
        this.win.close();
      }

      const url = await this.videoChatService.getVideoChatUrl();

      this.win = this.popupWindow(`${ url }${ videoChatRequest.ConnectionGroup }`, 'Video llamada');
      this.win.addEventListener('resize', function() {
      }, true);
    }
  }

  popupWindow(url: string, title: string) {
    return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + screen.width + ', height=' + (screen.height - 150) + ', top=0, left=0');
  }

  closeWin(): void {
    if ( this.win ) {
      this.win.close();
    }
  }
}
